import Header from './components/Header';
import Hero from './components/Hero';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <CommentsSection />

        <MediaSection />

        <CarouselSection />

        <AboutSection />

        <IndexSection />

        <CardsSection />

        <AppSection />

        <FeaturesSection />

        <FaqSection />

        <RankingSection />

        <ContactSection />

        <TopicsSection />

        <UpdatesSection />
      </main>

      <Footer />
    </div>
  );
}